import { render, staticRenderFns } from "./ExtraworkListAdd.vue?vue&type=template&id=bcb0d878&scoped=true"
import script from "./ExtraworkListAdd.vue?vue&type=script&lang=js"
export * from "./ExtraworkListAdd.vue?vue&type=script&lang=js"
import style0 from "./ExtraworkListAdd.vue?vue&type=style&index=0&id=bcb0d878&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb0d878",
  null
  
)

export default component.exports